import { TypedStorage } from "@utils/storage";
import { STORAGE_KEYS } from "@constants/storage-keys";
import { isElementsStorage } from "@validation/element.schema";
import type { ElementsStorage, StoredElement } from "@app-types/element.types";

const storage = new TypedStorage<ElementsStorage>(
  STORAGE_KEYS.ELEMENTS,
  isElementsStorage
);

/**
 * Get all selected elements from localStorage
 */
export function getElements(): ElementsStorage {
  return storage.getOrDefault({});
}

/**
 * Add or update an element for a specific group
 */
export function setElement(groupId: string, data: StoredElement): void {
  const elements = getElements();
  elements[groupId] = data;
  storage.set(elements);
}

/**
 * Remove an element by group ID
 */
export function removeElement(groupId: string): void {
  const elements = getElements();
  delete elements[groupId];
  storage.set(elements);
}

/**
 * Clear all selected elements
 */
export function clearElements(): void {
  storage.clear();
}

/**
 * Check if a specific group has an element selected
 */
export function hasElement(groupId: string): boolean {
  const elements = getElements();
  return groupId in elements;
}

/**
 * Get element for a specific group
 */
export function getElement(groupId: string): StoredElement | undefined {
  return getElements()[groupId];
}
